import { CSSProperties, useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import MapSearch from "./MapSearch";
import { setMapStateAction } from "redux/map/mapActions";
import { useDispatch } from "react-redux";
import "mapbox-gl/dist/mapbox-gl.css";

const parsiMapAccessToken = "p1e1137a728da548a583d250af45e06d4dd40cf7b1";
const token = "p1176d27b851984ebd8191ab0d54caecb52c995e58";

mapboxgl.accessToken = parsiMapAccessToken;

type Props = {
  parsiMapAddressData?: any;
  className?: string;
  height?: string;
};

const ParsiMapContent = ({ className = "", height = "100%" }: Props) => {
  let MarkerIcon;
  useEffect(() => {
    MarkerIcon = document?.createElement("div");
    MarkerIcon.className = "marker";
    MarkerIcon.style.backgroundImage = `url("/icons/mapbox-marker-icon.svg")`;
    MarkerIcon.style.width = `30px`;
    MarkerIcon.style.height = `70px`;
    MarkerIcon.style.backgroundSize = "100%";
  }, []);
  const dispatch = useDispatch();
  const mapContainer = useRef<any>(null);
  const [zoom, setZoom] = useState(15);
  const [mapObj, setMap] = useState({
    map: null,
    marker: null,
  });
  const defaultViewPort = {
    latitude: 35.69976003841564,
    longitude: 51.33808390275898,
    name: "تهران",
  };
  const [viewport, setViewPort] = useState({
    latitude: 0,
    longitude: 0,
  });
  const center: [number, number] = [viewport.longitude || defaultViewPort.longitude, viewport.latitude || defaultViewPort.latitude];

  const mapStyle: CSSProperties = {
    height: height,
  };

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainer.current || "",
      style: `https://okalaapi.parsimap.ir/styles/parsimap-streets-v11?key=${parsiMapAccessToken}`,
      center,
      zoom,
      doubleClickZoom: true,
      maxZoom: 19,
      minZoom: 4,
      scrollZoom: { around: "center" },
      touchZoomRotate: { around: "center" },
      accessToken: token,
    });
    if (mapboxgl.getRTLTextPluginStatus() === "unavailable") {
      mapboxgl.setRTLTextPlugin("https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js", (): void => {}, true);
    }

    let marker = new (mapboxgl as any).Marker(MarkerIcon).setLngLat(center).addTo(map);

    map.on("move", function (e: any) {
      const movedCenter = map.getCenter();
      marker.setLngLat(movedCenter);
    });
    map.on("dragend", async (e) => {
      const lastLatLng = marker.getLngLat();
      setViewPort({ latitude: lastLatLng.lat, longitude: lastLatLng.lng });
      dispatch(
        setMapStateAction({
          viewportNew: { latitude: lastLatLng.lat, longitude: lastLatLng.lng },
        })
      );
    });
    map.on("zoom", (e) => {
      setZoom(e.target.getZoom());
    });
    setMap(() => ({
      map,
      marker,
    }));
  }, []);

  useEffect(() => {
    if (mapObj.map) {
      (mapObj.map as any).setCenter(center);
      (mapObj.marker as any).setLngLat(center);
    }
  }, [viewport.latitude, viewport.longitude]);

  return (
    <>
      <div ref={mapContainer} style={mapStyle} className={`map-container z-0 w-full h-full absolute top-0 right-0 bottom-0 left-0 ${className}`}>
        <MapSearch setViewPort={setViewPort} />
      </div>
    </>
  );
};

export default ParsiMapContent;
